import React from 'react';
import FormStep from "../form-step";
import {Field, Form} from "formik";
import {renderField} from "../../../../utils/form-utils";
import * as Yup from "yup";
import ActionButtons from "../action-buttons";
import {CheckboxListField} from "../checkbox-list-field";
import StepLayout from "../step-layout";

const validationSchema = Yup.object().shape({
    assistance_type: Yup.array(Yup.string()).min(1,'Select at least one').required('Required'),
    project_timing: Yup.string().required('Required')
});

const Assistance = ({data, onNext}) => {
    const initialValues = {
        assistance_type: data.assistance_type || [],
        project_timing: data.project_timing || ''
    };

    return (
        <FormStep
            name="Assistance"
            initialValues={initialValues}
            validationSchema={validationSchema}
            onNext={onNext}
            footer={ <ActionButtons /> }
        >
            <StepLayout actions={<ActionButtons />}>
                <CheckboxListField
                name="assistance_type"
                items={[
                    "Cost reduction", "Undergoing digital transformation",
                    "Datacenter consolidation", "Agility/dev productivity",
                    "Acquisitions", "Large-scale compute workloads",
                    "Facility/real estate decisions", "Remote workforce",
                    "Collocation outsourcing changes", "Hardware refresh",
                    "Security / Compliance", "Availability / Reliability",
                    "Other",
                ]}
                customClass="columns-2"
                label="What are you looking for assistance on?"
            />

                <Field
                    type="select"
                    name="project_timing"
                    component={renderField}
                    label="What is your project timing?"
                >
                    <option value="">-- Please Select --</option>
                    <option value="This quarter">This quarter</option>
                    <option value="Next quarter">Next quarter</option>
                    <option value="Within next year">Within next year</option>
                    <option value="18 months+">18 months+</option>
                    <option value="I don't know">I don't know</option>
                </Field>
            </StepLayout>
        </FormStep>
    )
}

export default Assistance;